import { Route, Switch, Redirect  } from 'react-router-dom';

import NavMenu from './NavMenu';
import Header from '../components/layout/Header';
import AuthCodeMain from '../components/auth-code/AuthCodeMain';
import ClientCredMain from '../components/client-cred/ClientCredMain';
import AuthMdMain from '../components/auth-md/AuthMdMain';
import Authorize from '../components/authorize/Authorize';

function NavMain() {
  return <div>
    <Header></Header>
    <NavMenu></NavMenu>
    <Switch>
      <Route path='/' exact>
        <AuthCodeMain></AuthCodeMain>
      </Route>
      <Route path='/cc' exact>
        <ClientCredMain></ClientCredMain>
      </Route>
      <Route path='/md' exact>
        <AuthMdMain></AuthMdMain>
      </Route>
      <Route path='/authorize'>
        <Authorize></Authorize>
      </Route>
      <Route>
        <Redirect to="/" />
      </Route>        
    </Switch>
  </div>
}

export default NavMain;
